import { ElementProps } from '@codeparva/ui-components-library/dist/components/element';
import React from 'react';
import { TextTypes } from './TextTypes';

export const Text = ({
  renderAs: RenderAs = 'p',
  children,
  ...otherprops
}: TextTypes.IText | ElementProps) => {
  return (
    <RenderAs className="text" {...otherprops}>
      {children}
    </RenderAs>
  );
};
